import { makeStyles } from '@material-ui/core';

import { BOX_SHADOW_OPT_2 } from '../../shared/consts';
import { COLOR_TONE } from '../../../../shared/styles/colors';

import type { SaturationStateProp } from '../../shared/models';

export default makeStyles(theme => ({
  article: ({ showCTA }: Props) => ({
    padding: '0.75rem',
    '&>:last-child': { paddingBottom: 0 },
    display: 'flex',
    gap: '0.75rem',
    cursor: showCTA ? 'pointer' : 'inherit',
    borderRadius: '0.5rem',
    border: `1px solid ${COLOR_TONE.gray['10']}`,
    boxShadow: 'none',
    '&:hover': {
      boxShadow: showCTA ? BOX_SHADOW_OPT_2 : 'none',
      backgroundColor: showCTA ? COLOR_TONE.gray.A20 : 'inherit',
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  }),
  header: {
    padding: 0,
    flexGrow: 1.5,
    contain: 'inline-size',
  },
  title: {
    fontSize: '0.875rem',
    fontWeight: 600,
    lineHeight: '1.5rem',
    color: COLOR_TONE.gray.A90,
    display: '-webkit-box',
    overflow: 'hidden',
    textWrap: 'pretty',
    // whiteSpace: 'pre-wrap',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
  subtitle: {
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    color: COLOR_TONE.gray['50'],
    display: '-webkit-box',
    overflow: 'hidden',
    textWrap: 'pretty',
    // whiteSpace: 'pre-wrap',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
  main: {
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
}));

interface Props extends SaturationStateProp {
  showCTA: boolean;
}
